// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rRJF","questions":"styles_questions__2RSKm","footer":"styles_footer__1S-5Z"};